import React from 'react'
import {SvgIcon} from 'rambler-ui'

export default function AttentionIcon(props) {
  return (
    <SvgIcon {...props} viewBox={props.size === 15 ? '0 0 15 15' : '0 0 20 20'}>
      {props.size === 15 ? (
        <path
          fillRule="evenodd"
          d="M15 15V0M0 15V0m7.7 9.8h-.4c-.276 0-.5.224-.5.5v.4c0 .276.224.5.5.5h.4c.276 0 .5-.224.5-.5v-.4c0-.276-.224-.5-.5-.5M7.35 9h.3c.276 0 .5-.224.5-.5v-4c0-.276-.224-.5-.5-.5h-.3c-.276 0-.5.224-.5.5v4c0 .276.224.5.5.5m.15-9C3.358 0 0 3.358 0 7.5 0 11.642 3.358 15 7.5 15c4.142 0 7.5-3.358 7.5-7.5C15 3.358 11.642 0 7.5 0m0 1.2c3.474 0 6.3 2.826 6.3 6.3 0 3.474-2.826 6.3-6.3 6.3-3.474 0-6.3-2.826-6.3-6.3 0-3.474 2.826-6.3 6.3-6.3"
        />
      ) : (
        <path
          fillRule="evenodd"
          d="M10.9 13.1v.8c0 .276-.224.5-.5.5h-.8c-.276 0-.5-.224-.5-.5v-.8c0-.276.224-.5.5-.5h.8c.276 0 .5.224.5.5M20 0v20M0 0v20M10 2c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8m0 1.5c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5m.326 8.1h-.652c-.266 0-.485-.208-.499-.473l-.247-4.6c-.015-.286.213-.527.5-.527h1.145c.286 0 .514.241.499.527l-.247 4.6c-.014.265-.233.473-.499.473"
        />
      )}
    </SvgIcon>
  )
}
